import { ProductTypeIDs } from "./ProductUtils";

export const getInfoWarningTypeDisplayName = (type: InfoWarningType) => {
	switch (type) {
		case InfoWarningType.Error:
			return "Chyba";
		case InfoWarningType.Info:
			return "Info";
		case InfoWarningType.Tip:
			return "Tip";
		case InfoWarningType.Warning:
			return "Varování";
		default:
			return "";
	}
};

export const getInfoWarningVisibilityDisplayName = (
	visibility: InfoWarningVisibility
) => {
	switch (visibility) {
		case InfoWarningVisibility.All:
			return "Vždy";
		case InfoWarningVisibility.Standard:
			return "Standardní instance";
		case InfoWarningVisibility.Selfins:
			return "Samosjednávací instance";
	}
};

export const getInfoWarningPlacementDisplayName = (
	placement: InfoWarningPlacement
) => {
	switch (placement) {
		case InfoWarningPlacement.Insurance:
			return "Pojištění (produkt)";
		case InfoWarningPlacement.HomePage:
			return "Úvodní stránka";
		case InfoWarningPlacement.LoginPage:
			return "Přihlašovací stránka";
		default:
			return "";
	}
};

export const parseInfoWarningPlacements = (
	placements: string | null | undefined
): number[] => {
	if (!placements) {
		return [InfoWarningPlacement.Insurance];
	}
	return placements.split(";").map(Number);
};

export const getInfoWarningPlacementsDisplayName = (
	placements: string | null | undefined
): string =>
	parseInfoWarningPlacements(placements)
		.map((x) => getInfoWarningPlacementDisplayName(x))
		.join("; ");

export const hasInsurancePlacement = (
	placements: number[] | null | undefined
) => !!placements?.includes(InfoWarningPlacement.Insurance);

export const getInfoWarningProducts = () => {
	return [
		ProductTypeIDs.LiabilityInsurance,
		ProductTypeIDs.CollisionDamageInsurance,
		ProductTypeIDs.VehicleInsurance,

		ProductTypeIDs.PropertyInsurance,
		ProductTypeIDs.HouseholdInsurance,
		ProductTypeIDs.PropertyAndHouseholdInsurance,

		ProductTypeIDs.SingleTravel,
		ProductTypeIDs.MultipleTravelsInYear,
		ProductTypeIDs.AnnualStay,

		ProductTypeIDs.ThirdPartyInsurance,
		ProductTypeIDs.EmployeeResponsibility,

		ProductTypeIDs.MortgagePaymentAndClientCredit,
		ProductTypeIDs.MortgageAmericanMortgage,
		ProductTypeIDs.MortgageComparisonConsumerCredit,
		ProductTypeIDs.MortgageBuildingSavings,
		ProductTypeIDs.MortgageCalculator,
		ProductTypeIDs.RepayAbilityInsurance,

		ProductTypeIDs.LifeInsurance,

		ProductTypeIDs.Investment,

		ProductTypeIDs.VehiclePovMethodology,
		ProductTypeIDs.VehicleHavMethodology,
		ProductTypeIDs.PropertyMethodology,
		ProductTypeIDs.HouseholdMethodology,
		ProductTypeIDs.FlatMethodology,
		ProductTypeIDs.TravelMethodology,
		ProductTypeIDs.MortgageMethodology,
		ProductTypeIDs.MortgageAmericanMethodology,
		ProductTypeIDs.MortgageMethodologyConsumerCredit,
		ProductTypeIDs.MortgageMethodologyBuildingSavings,
		ProductTypeIDs.LifeInsuranceMethodology,

		ProductTypeIDs.VehicleAssistanceInsurance,
		ProductTypeIDs.TravelAssistanceInsurance,

		ProductTypeIDs.VehiclePersonalAccidentInsurance,

		ProductTypeIDs.DogInsurance,
		ProductTypeIDs.CatInsurance,
		ProductTypeIDs.SmeInsurance,

		ProductTypeIDs.CyberInsurance,
	];
};

export enum InfoWarningType {
	Warning = 0,
	Error = 1,
	Info = 2,
	Tip = 3,
}

export enum InfoWarningVisibility {
	All = 0,
	Standard = 1,
	Selfins = 2,
}

export enum InfoWarningPlacement {
	Insurance = 0,
	HomePage = 1,
	LoginPage = 2,
}
